import { useQuery } from '@apollo/client/react';
import { useEffect } from 'react';

import { useConfig } from 'src/context/config';
import { useJobId } from 'src/context/useJobId';
import { logError } from 'src/modules/error-logger/browserLog';
import { getGraphQLErrors } from 'src/modules/graphql-client/errors';
import { GET_JOB } from 'src/modules/graphql-client/queries/jobs.graphql';
import { getOperationNameFromQuery } from 'src/modules/utils';

export const useJobDetails = () => {
  const { jobId } = useJobId();
  const { config } = useConfig();
  const { data, loading, error } = useQuery(GET_JOB, {
    variables: {
      jobId,
      locale: config.VOCAB_LANGUAGE,
    },
  });

  useEffect(() => {
    if (!error) {
      return;
    }

    logError(
      {
        message: 'Failed to resolve jobDetails',
        graphQLErrors: getGraphQLErrors(error),
        type: 'jobdetails-fetch-failed',
      },
      { jobId, operationName: getOperationNameFromQuery(GET_JOB) },
    );
  }, [error, jobId]);

  return {
    data: data?.jobDetails?.job,
    loading,
    error,
  };
};
